<template>
  <div class="home__tour-list">
    <home-tour-card v-for="tour in getTourList()" :key="tour.id" :tour="tour"></home-tour-card>
  </div>
</template>

<script>
import HomeTourCard from "./HomeTourCard.vue";

export default {
  name: "HomeTourList",
  data() {
    return {
      active: 0
    };
  },
  props: {
    msg: String
  },
  components: {
    HomeTourCard
  }
};
</script>

<style scoped lang="scss">
.home__tour-list {
  max-width: 1080px;
  margin: auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0 12px;
}

@media (max-width: 767px) {
  .home__tour-list {
    max-width: 500px;
  }
}
</style>
